import { IProduct, Product } from "@/entities";
import { IProductRepository } from "./product.types";
import axios from "axios"

export class ProductAPIRepository implements IProductRepository {
    async getAllProduct(): Promise<Map<number, IProduct>> {
        const response = await axios.get('https://villa-saletool-production-products.s3.ap-southeast-1.amazonaws.com/onlineData')
        if (response.status === 200) {
            const productsData = response?.data.data
            const productsColumns = response?.data.columns
            const productMap = new Map()
            productsData.forEach((item: any) => {
                const product: any = {}
                productsColumns.forEach((col: string, index: number) => {
                    product[`${col}`] = item[index]
                });
                const p = new Product(product)
                productMap.set(p.cprcode, p)
            });
            return productMap;
        } else {
            throw new Error("Failed to load product");
        }
    }
}